module.exports = __webpack_public_path__ + "img/ic_64_workouts.47a9f968.svg";